import { Navigate } from "react-router";

// Preserve existing feature-configuration links during the access-model transition.
// Features are ordinary Role Permissions; Groups own their GLOBAL assignments.
export function AccessConfigFeaturesPanel() {
  return <Navigate to="/admin/settings?section=accessRoles" replace />;
}
